<template>
  <div class="thumbnail-wrap">
    <received-badge
      v-if="showingReceivedBadge"
      v-tooltip="badgeTooltip"
    />
    <img
      class="object-cover w-full h-full rounded"
      v-if="presentation.thumbnailImage || presentation.customThumbnailImage"
      :src="getThumbnailUrl"
    >
    <img
      class="object-cover w-full h-full rounded"
      v-else
      src="@/assets/images/icon/default-thumbnail.svg"
    >
    <aha-icon
      v-if="showIconShared"
      name="users"
      width="20"
      height="20"
      viewBox="-4 -4 20 20"
      class="absolute -top-1.5 -left-1.5 rounded-full border-2 border-purple-10 bg-white-100 text-base-70"
    />
  </div>
</template>

<script>
import ReceivedBadge from './ReceivedBadge.vue'

// presentation.createdAt is always != presentation.updatedAt when duplicate prez
// So any update within created threshold is counted as "just received"
const JUST_RECEIVED_THRESHOLD = 30 * 1000

export default {
  components: {
    ReceivedBadge,
  },
  props: {
    presentation: {
      type: Object,
      default: null,
    },
    showIconShared: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    badgeTooltip() {
      if (this.presentation.sender) {
        return this.$i18nPresenter.t('justReceivedFromX', {
          sender: this.presentation.sender,
        })
      }
      return this.$i18nPresenter.t('Just received from your teammate')
    },

    // received badge will show when presentation is NOT yet edited
    // (meaning timeDiffMillisec is < threshold)
    showingReceivedBadge() {
      const timeDiffMillisec =
      new Date(this.presentation.createdAt) - new Date(this.presentation.updatedAt)
      return this.presentation.sender
        && Math.abs(timeDiffMillisec) < JUST_RECEIVED_THRESHOLD
    },
    getThumbnailUrl() {
      if (this.presentation.customThumbnailImage) {
        return this.presentation.customThumbnailImage
      }
      return this.presentation.thumbnailImage
    },
  },
}
</script>

<style>
  .thumbnail-wrap {
    @apply w-20 block cursor-pointer relative;
    height: 45px; /** using 16/9 aspect ratio, similar to default-thumbnail's aspect ratio */
  }
</style>
